<template>
  <div class="bill-registry-page">
    <transactions-page-controls
      :has-filter="false"
      :has-export="false"
      :has-total-stats="false"
      :has-stats="false"
      :specific-actions-to-right="true"
      @refresh="loadBillsRegistries"
    >
      <template #plainFilter>
        <div class="bill-registry__date-filter">
          <custom-date-picker
            :config="{ floatingTitle: true, transparent: true }"
            v-model:value="filter.dateFrom"
            :should-translate-title="true"
            :label="$t('bills.filter.date_from')"
          ></custom-date-picker>
          <custom-date-picker
            :config="{ floatingTitle: true, transparent: true }"
            v-model:value="filter.dateTo"
            :should-translate-title="true"
            :label="$t('bills.filter.date_to')"
          ></custom-date-picker>
        </div>
      </template>
      <template #specificActions>
        <primary-button
          class="bill-registry__upload-btn"
          :label="$t('payouts.by-registry.actions.upload')"
          @click="uploadBillRegistry"
        ></primary-button>
      </template>
    </transactions-page-controls>
    <bills-registries-table
      :bills-registries-list="billsRegistries"
      v-if="!isDataLoading"
      @registryDeleted="handleRegistryDeleted"
    ></bills-registries-table>
    <loader v-else></loader>
    <success-notification
      ref="registryDeletedNotification"
      :text="$t('payouts.by-registry.notifications.registry-deleted')"
    ></success-notification>
  </div>
</template>

<script>
import responsiveMixin from '@vue-app/mixins/responsive-mixin'

import { mapGetters, mapState } from 'vuex'
import PayoutsToCardTable from '@vue-app/components/company/payouts/to-card/table/PayoutsToCardTable.vue'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'
import TransactionsPageControls from '@vue-app/components/company/transactions/shared/transactions-page-controls/TransactionsPageControls.vue'
import { Stats } from '@js-app/entities/transaction/Stats'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import CustomDatePicker from '@vue-app/components/base/input/CustomDatePicker.vue'
import Loader from '@vue-app/components/base/Loader.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import BillsRegistriesTable from '@vue-app/components/company/bills/table/BillsRegistriesTable.vue'

export default {
  name: 'BillRegistriesPage',
  components: {
    SuccessNotification,
    Loader,
    CustomDatePicker,
    PrimaryButton,
    TransactionsPageControls,
    RequireAccess,
    PayoutsToCardTable,
    BillsRegistriesTable,
  },
  props: {
    id: {
      type: [String, Number],
    },
  },
  mixins: [responsiveMixin],
  data() {
    return {
      isDataLoading: false,
      payoutsToCardStats: new Stats(),
      billsRegistries: [],
      filter: {
        dateFrom: this.$moment().subtract('1', 'month').toDate(),
        dateTo: this.$moment().toDate(),
      },
    }
  },

  computed: {
    ...mapState(['selectedCompany']),
  },
  watch: {
    filter: {
      handler: 'loadBillsRegistries',
      deep: true,
      flush: 'post',
    },
  },
  created() {
    this.startupPage()
  },
  methods: {
    async startupPage() {
      await this.loadBillsRegistries()
    },
    async loadBillsRegistries() {
      const filterFormatted = {
        date_from: this.filter.dateFrom.toLocaleString(),
        date_to: this.filter.dateTo.toLocaleString(),
      }

      this.isDataLoading = true
      this.billsRegistries =
        (
          await CompaniesApi.getBillsRegistries(
            {
              company_id: this.selectedCompany,
            },
            filterFormatted
          )
        ).data || []
      this.isDataLoading = false
    },
    uploadBillRegistry() {
      this.$router.push({
        name: 'bill-registries-create',
        params: {
          id: this.selectedCompany,
        },
      })
    },
    handleRegistryDeleted(registry) {
      this.$refs.registryDeletedNotification.show()
      this.billsRegistries.splice(
        this.billsRegistries.findIndex((_r) => _r.id === registry.id),
        1
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.bill-registry {
  &-page {
    .transactions-page-controls {
      margin-top: 30px;
    }

    .bills-registries-table {
      margin-top: 10px;
    }
  }

  &__date-filter {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    align-self: flex-end;
    margin-left: 10px;
    margin-right: auto;
  }
}
</style>
